import React, { useContext } from "react";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import { Divider, Grid } from "@material-ui/core";
import Typography from "@components/Typography";
import { ColProps_1 } from "@core/utils/ColProps";
import PriceFormat from "@components/PriceFormat";
import RecentTransactionsList from "./RecentTransactionsList";
import { StatsContext } from "@context/statsContext";
import { useParams } from "react-router-dom";
import ColumnRecentTransactionsList from "./ColumnRecentTransactionsList";

const OrderBook = ({ type, itemsNumber, template }) => {
  const classes = useStyles();
  const { statsState } = useContext(StatsContext);
  const { currencyName } = useParams();
  const statItem = statsState?.stats[currencyName?.replace("-", "_")];
  const dayClose = statItem?.dayClose;

  const checkColor = (price) => {
    if (price > dayClose) {
      return "primary.tint90";
    } else if (price < dayClose) {
      return "red2.main";
    } else {
      return "";
    }
  };

  return type === "column" ? (
    <ColumnRecentTransactionsList
      currencyName={currencyName}
      itemsNumber={itemsNumber}
      template={template}
    />
  ) : (
    <Grid container direction="column" justify="center">
      <Grid item container direction="column" alignItems="center">
        <Grid item className={classes.lastDeal}>
          <Typography
            variant="sm"
            isBold
            color={checkColor(statItem?.unitPrice)}
          >
            {<PriceFormat price={statItem?.unitPrice} />}
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="3xs">{__t("The Last Deal")}</Typography>
        </Grid>
      </Grid>
      <Grid item {...ColProps_1}>
        <Divider light className={classes.divider} />
      </Grid>
      <RecentTransactionsList currencyName={currencyName} />
    </Grid>
  );
};

export default OrderBook;
